import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile, } from "../../../Services/ApiTestService/aadharTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { generateOtpForMobileToUdyamLookup } from "../../../Services/ApiTestService/panTestService";
import { FaCopy, FaIdBadge } from "react-icons/fa";
import {DataPanUdyam} from "../Data";
import { useService } from "../../../context/ServiceContext";

const MobileToUdyamLookup = () => {
    const [mobileNumber, setMobileNumber] = useState('');
    const [otp , setOtp] = useState('')
    const [errors, setErrors] = useState({});
    const [showOtpInputBox , setShowOtpInputBox] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [profileData, setProfileData] = useState({});
    const [panDetails, setPanDetails] = useState(null);
    const { serviceName } = useService();

    const handleSubmit = async () => {
        try {
            if (mobileNumber === "") {
                errors.mobileNumber = 'Mobile Number is required.';
                return
            } 
            const payload = {
                "api_id": profileData?.user_id,
                "api_key": profileData?.api_key,
                "token_id": profileData?.token_id,
                "methodName" : "generateOtp",
                "mobile_number": mobileNumber,
            }
            setIsLoading(true);
            setErrors({})
            let response = await generateOtpForMobileToUdyamLookup(payload);
            //  let response = panverificationFormdata
            setIsLoading(false)
            console.log(response)
            if (response.status.code === 200) {

                setPanDetails(response.data || response.data.data || [])
                showSuccessToast(response.message || response.data.message || "Udyam Registration Number Verified successfully");
                setShowOtpInputBox(true)

            } else {
                showErrorToast(response.message || response.data.message || response.error.message || "Failed to send otp")
            }
        } catch (error) {
            setIsLoading(false);
            showErrorToast('Something went wrong')
        }
    }

    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }


    // Fetch Profile Data on Mount
    useEffect(() => {
        async function fetchProfileData() {
            try {
                setIsLoading(true);
                const response = await fetchProfile(); // API call to get profile details
                setProfileData(response.data);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching profile data", error);
                showErrorToast("Failed to fetch profile data.");
                setIsLoading(false);
            }
        }
        fetchProfileData();
    }, []);

 


    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }
    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />


            {/* Go Back Button */}
            <div className="w-full md:w-auto flex justify-end md:justify-end order-1">
                <Link
                    to="/TestMaster"
                    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-2 py-1 rounded-md font-semibold shadow-md transition duration-300"
                >
                    <span>Go Back</span>
                    <IoArrowBackCircleOutline size={24} />
                </Link>
            </div>
            <div className="flex flex-wrap gap-3 justify-start md:ml-64 ml-0">


                {/* Mobile Number Input */}
                <div className="w-full md:w-1/6 order-2">
                    <InputWithLabel
                        type="text"
                        label="Mobile Number"
                        placeholder="Mobile No"
                        className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full uppercase"
                        name="mobileNo"
                        id="mobileNo"
                        required={true}
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        error={errors.mobileNumber}
                    />

                </div>

                {
                    showOtpInputBox && (
                        <div className="w-full md:w-1/6 order-2">
                            <InputWithLabel
                                type="text"
                                label="OTP"
                                placeholder="OTP"
                                className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full uppercase"
                                name="otp"
                                id="otp"
                                required={true}
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                            />
                        </div>
                    )
                }


                <div className="w-full md:w-auto order-3">
                    <Button
                        type="button"
                        className="text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 hover:from-blue-900 hover:to-blue-400 border-4"
                        id="sendOtp"
                        name="sendOtp"
                        text="Send Otp"
                        onClick={handleSubmit}
                    />
                </div>

                {
                    showOtpInputBox && (
                    <div className="w-full md:w-auto order-3">
                        <Button
                            type="button"
                            className="text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 hover:from-blue-900 hover:to-blue-400 border-4"
                            id="verifyOtp"
                            name="verifyOtp"
                            text="Verify Otp"
                        />
                    </div>
                    )
                }
            </div>



{panDetails && (

  <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
    {/* Left: Udyam Basic Card Data */}
    <div>
      <div className="relative bg-white/70 backdrop-blur-lg border border-blue-100 p-6 rounded-2xl shadow-xl max-w-2xl mx-auto">
        {/* Decorative Chip */}
        <div className="absolute top-4 right-4 w-10 h-6 bg-yellow-400 rounded-sm shadow-inner" />

        <div className="mb-4 flex items-center gap-2">
          <FaIdBadge className="text-blue-600 text-xl" />
          <h2 className="text-2xl font-bold text-blue-900">
            {panDetails.enterprise_data?.official_name || "Name not available"}
          </h2>
        </div>

        <div className="text-gray-700 text-sm space-y-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 text-md gap-2">
            <div><strong>Udyam Reg. No:</strong> {panDetails.enterprise_data?.udyam_reg_no || "N/A"}</div>
            <div><strong>Major Activity:</strong> {panDetails.enterprise_data?.major_activity || "N/A"}</div>
            <div><strong>Enterprise Type:</strong> {panDetails.enterprise_data?.enterprise_type || "N/A"}</div>
            <div><strong>Organization Type:</strong> {panDetails.enterprise_data?.organization_type || "N/A"}</div>
            <div><strong>Mobile:</strong> {panDetails.enterprise_data?.official_mobile || "N/A"}</div>
            <div><strong>Email:</strong> {panDetails.enterprise_data?.official_email || "N/A"}</div>
            <div><strong>District:</strong> {panDetails.enterprise_data?.official_address?.district || "N/A"}</div>
            <div><strong>State:</strong> {panDetails.enterprise_data?.official_address?.state || "N/A"}</div>
          </div>

          <div className="mt-4">
            <strong>Full Address:</strong>
            <p className="text-sm text-gray-600">
              {[
                panDetails.enterprise_data?.official_address?.door_no,
                panDetails.enterprise_data?.official_address?.building_name,
                panDetails.enterprise_data?.official_address?.street,
                panDetails.enterprise_data?.official_address?.city,
                panDetails.enterprise_data?.official_address?.district,
                panDetails.enterprise_data?.official_address?.state,
                panDetails.enterprise_data?.official_address?.pincode,
              ]
                .filter(Boolean)
                .join(", ") || "N/A"}
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* Right: JSON API Response */}
    <div>
      <h3 className="bg-green-200 text-xl font-bold my-2 rounded p-2">
        API Response
      </h3>
      <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
        <FaCopy
          className="absolute top-2 right-2 cursor-pointer bg-white p-1 rounded-md text-2xl font-bold"
          onClick={() => handleCopyText(JSON.stringify(panDetails, null, 2))}
        />
        {JSON.stringify(panDetails, null, 2)}
      </pre>
    </div>
  </div>
)}


            <div class="max-w-3xl mx-auto p-1 md:p-1 bg-white rounded-3xl shadow-2xl mt-1 border border-gray-200 transition-transform duration-300 hover:scale-[1.01]">
                <h2 class="text-2xl font-extrabold text-center text-gray-900 mb-3 tracking-tight">
                    🔐 Mobile to Udyam Lookup Verification Steps
                </h2>

                <ol class="list-decimal text-gray-800 space-y-3 pl-6 relative">
                    <li class="relative group hover:pl-4 transition-all duration-300">
                        <span class="inline-block group-hover:text-blue-600 transition-colors duration-300">
                            Enter your <span class="font-medium text-gray-900">Mobile number</span> carefully.
                        </span>
                    </li>
                    <li class="relative group hover:pl-4 transition-all duration-300">
                        <span class="inline-block">
                            Click on <span class="font-semibold text-blue-600 underline underline-offset-2 group-hover:text-blue-800 transition-colors duration-300">“Submit ”</span> to verify your Udhyam number.
                        </span>
                    </li>



                </ol>

                <div class="mt-6 border-t border-gray-300 pt-1">
                    <h3 class="text-xl font-bold text-gray-900 mb-1 flex items-center gap-2">
                        📌 Important Notes
                        <span class="text-yellow-500 animate-pulse text-lg">⚠️</span>
                    </h3>
                    <ul class="list-disc text-gray-700 space-y-2 pl-6">
                        <li class="hover:text-blue-600 transition duration-300">
                            Ensure the correct mobile number .
                        </li>
                        <li class="hover:text-blue-600 transition duration-300">
                            Do not refresh the page during the verification process.
                        </li>

                    </ul>
                </div>
            </div>



        </>
    );
};

export default MobileToUdyamLookup;  



